import React from "react";
import "./about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component
import { Box, Typography } from "@mui/material";

const Education = () => {
  const sections = [
    {
      image: "Images/About/edu1.png",
      text: "JAMIA NIDA-E-ISLAM is a distinguished educational institution founded on the principle that 'Knowledge is Light.' It is dedicated to providing a robust academic foundation for students from Nursery to Grade 5 while emphasizing the development of moral character and life skills. The school stands as a guiding light in the community, nurturing young minds and fostering a culture of curiosity, creativity, and compassion. By prioritizing both academic excellence and values-based education, JAMIA NIDA-E-ISLAM aims to shape students into individuals ready to embrace the challenges of a rapidly changing world.",
    },
    {
      image: "Images/About/edu2.png",
      text: "The school’s curriculum is designed with a forward-thinking approach, combining modern pedagogical practices with the timeless wisdom of traditional learning. This thoughtful integration ensures students receive a well-rounded education that equips them with a strong grasp of core subjects such as language, mathematics, and science, while also encouraging exploration of arts and cultural activities. Through this balanced educational approach, JAMIA NIDA-E-ISLAM creates an environment where students develop a love for learning and acquire critical thinking and problem-solving skills essential for their future endeavors.",
    },
    {
      image: "Images/About/edu3.png",
      text: "At JAMIA NIDA-E-ISLAM, learning extends beyond the boundaries of the classroom. Teachers are committed to creating a dynamic and interactive educational experience, utilizing innovative teaching methods that cater to the diverse learning styles of students. From hands-on activities and collaborative projects to storytelling and creative workshops, the teaching methodology ensures that each child is actively engaged in the learning process. This inclusive approach not only enhances academic understanding but also boosts confidence, communication, and teamwork skills among students.",
    },
    {
      image: "Images/Gallery/image13.png",
      text: "The institution also believes that education is not just about acquiring knowledge but about building character and instilling values that last a lifetime. Alongside their academic pursuits, students are guided to develop qualities such as empathy, integrity, and responsibility. Through various programs and initiatives, JAMIA NIDA-E-ISLAM encourages students to understand the importance of contributing to their communities, fostering a sense of social responsibility from an early age.",
    },
    {
      image: "Images/Gallery/image15.jpg",
      text: "Despite being a growing institution, JAMIA NIDA-E-ISLAM takes immense pride in its dedication to its mission of creating a brighter future for its students and society. By investing in innovative teaching practices, supportive learning environments, and co-curricular activities, the school continually seeks to enhance the educational experience it offers. JAMIA NIDA-E-ISLAM stands as a testament to the transformative power of education, guiding its students toward a path of lifelong learning, meaningful achievements, and positive societal impact.",
    },
  ];

  return (
    <div className="about-education">
      <Header />
      <main className="content">
        {/* Hero Section */}
        <section className="hero">
          <img
            src="Images/About/header.png"
            alt="Education Background"
            className="hero-image"
          />
          <div className="overlay">
            <h1 className="title">
              Education
            </h1>
          </div>
        </section>

        {/* Content Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "16px",
            marginLeft: { xs: "auto", md: "50px" },
            marginRight: { xs: "auto", md: "50px" },
          }}
        >
          {sections.map((section, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  md: index % 2 === 0 ? "row" : "row-reverse",
                },
                gap: 3,
                alignItems: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box
                component="img"
                src={section.image}
                alt={`Section ${index}`}
                sx={{
                  flex: 1,
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  maxWidth: { md: "25%" },
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  flex: 1,
                  fontSize: "1.1rem",
                  textAlign: "justify",
                  color: "#555",
                }}
              >
                {section.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </main>
      <Footer />
    </div>
  );
};

export default Education;
